export default __webpack_public_path__ + "partner_5b31d15.png";